import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import { onError } from 'apollo-link-error'
import VueApollo from 'vue-apollo'
import { API_URL, WRITABLE_API_URL } from '@/constants'
import introspectionQueryResultData from './introspection-result'

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
})

const httpLink = new HttpLink({
  uri: `${API_URL}/gql`
})

const writableHttpLink = new HttpLink({
  uri: `${WRITABLE_API_URL}/gql`
})

const cache = new InMemoryCache({ fragmentMatcher })

// const currentVersion = process.env.VUE_APP_VERSION || version
// const localVersion = localStorage.getItem('WIVI_VERSION') || ''

// console.log('VERSION FROM APOLLO', currentVersion)
// console.log('LOCALVERSION FROM APOLLO', localVersion)

// if (localVersion !== currentVersion) {
//   localStorage.setItem('WIVI_VERSION', currentVersion)
//   localStorage.removeItem('wivi-visit-gql-persit')
// }

// Set up cache persistence.
// persistCache({
//   cache,
//   storage: window.localStorage,
//   // key: 'wivi-visit-gql-persit',
// });

// const trigger = (persist: any) => {
//   // Call `persist` every 10 seconds.
//   const interval = setInterval(persist, 10000);

//   // Return function to uninstall this custom trigger.
//   return () => clearInterval(interval);
// }

// const persistor = new CachePersistor({
//   cache,
//   storage: window.localStorage as PersistentStorage<PersistedData<NormalizedCacheObject>>,
//   key: 'wivi-visit-gql-persit',
//   trigger
// })

// async function initializeCache () {
//   const currentVersion = process.env.VUE_APP_VERSION || version
//   const localVersion = localStorage.getItem('WIVI_VERSION') || ''

//   console.log('VERSION FROM APOLLO', currentVersion)
//   console.log('LOCALVERSION FROM APOLLO', localVersion)

//   if (localVersion !== currentVersion) {
//     localStorage.setItem('WIVI_VERSION', currentVersion)
//     localStorage.removeItem('wivi-visit-gql-persit')
//     // await persistor.purge()
//   } else {
//     await persistor.restore()
//   }
// }

// initializeCache()

// Error Handling
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `[Wivi][GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    )
  }
  if (networkError) console.error(`[Wivi][Network error]: ${networkError}`)
})

// Create the apollo client
export const apolloClient = new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, httpLink]),
  connectToDevTools: process.env.NODE_ENV !== 'production',
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }
})

// Create the master apollo client for cache version
export const writableApolloClient = new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, writableHttpLink])
})

export const apolloProvider = new VueApollo({
  clients: {
    'apolloClient': apolloClient,
    'writableApolloClient': writableApolloClient
  },
  defaultClient: apolloClient
})

// Install the Vue plugin
Vue.use(VueApollo)
